"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportCodeTimes = void 0;
var ExportCodeTimes;
(function (ExportCodeTimes) {
    ExportCodeTimes["DAY"] = "day";
    ExportCodeTimes["LASTRUN"] = "last-run";
    ExportCodeTimes["DATE_RANGE"] = "date-range";
})(ExportCodeTimes || (exports.ExportCodeTimes = ExportCodeTimes = {}));
